/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        17/02/2020      2560: 400 Bad Request Issue with gemtriageapi-qa3 POST GemTriage/UpdateTriageLogSymptoms
*********************************************************************************/
import { Link } from '@mna/react'
import PageTitle from 'features/PageTitle'
import {Trans} from 'react-i18next'
import { checkAndGetLocalStorageValue } from "../../../features/utils";
import i18next from 'i18next';
const confirmTitle=<Trans i18nKey="findcareoption.confirm.confirm_title">Is this information correct?</Trans>

export default ({
    actions, history,state
}) =>{ state.triageRequest.activeMenu = "care-options"
    return(<div className="standby-content standby-content-bottom-nav">
        <article className="standby-article bottom">
            <div className="standby-center">
                <PageTitle
                    titleText={confirmTitle}
                    align="center"
                />              
            </div>
        <div className="standby-input-info">
        <h2 className='fontWeight'><Trans i18nKey="findcareoption.confirm.confirm_subtitle1"> Your Details:</Trans></h2>
            <ul>
            {state.IsValidUser && state.triageRequest.data.username &&(
                <li>
                   <Trans i18nKey="findcareoption.Start.Name">Name</Trans>: {state.triageRequest.data.username} 
                </li>
              )}

                {(state.triageRequest.data.email) && 
                <li>
                  <Trans i18nKey="findcareoption.Careoptions.Email">Email</Trans>: {state.triageRequest.data.email}
                </li>}            
                {(state.triageRequest.data.mobile) && 
                <li>
                 : {state.triageRequest.data.mobile}
                </li>}
                {(state.triageRequest.data.phone) && 
                <li>
                  <Trans i18nKey="findcareoption.Careoptions.PhoneNumber">Phone Number</Trans>: {state.triageRequest.data.phone}
                </li>}
                {(state.triageRequest.data.extensionOrRoomNumber) && 
                <li>
                  <Trans i18nKey="findcareoption.Careoptions.ExtensionRoom">Extension / Room #</Trans>: {state.triageRequest.data.extensionOrRoomNumber}
                </li>}   
                {(state.triageRequest.userContact === "Email" ?
                  <li>
                    <Trans i18nKey="Preferredcontact">Preferred contact method</Trans>: {i18next.t("findcareoption.Careoptions.sendinfo.Email")}
                  </li> :
                  state.triageRequest.userContact === "Phone" ?
                  <li>
                    <Trans i18nKey="Preferredcontact">Preferred contact method</Trans>: {i18next.t("findcareoption.Careoptions.Phone")}
                  </li> : 
                  ""
                )}
                {(state.triageRequest.data.notes) && 
                <li>
                  <Trans i18nKey="findcareoption.Careoptions.notes">Notes</Trans>: {state.triageRequest.data.notes}
                </li>} 
                
                {state.IsValidUser && state.triageRequest.data && state.triageRequest.data.insurance && (
                    <li><Trans i18nKey = "userregistration.insurancecarrier">Insurance carrier</Trans>: {state.triageRequest.data.insurance}</li>
                )}
                
                {state.IsValidUser && state.triageRequest.data.policyNum && (
                    <li>
                      {" "}
                      <Trans i18nKey="findcareoption.Start.Policy">
                        Policy #
                      </Trans>: {state.triageRequest.data.policyNum}
                    </li>
                  )}
                
                  {state.IsValidUser && state.triageRequest.EffectFrom && state.triageRequest.EffectTo && (
                    <li>
                      <Trans i18nKey="findcareoption.Start.Traveldates">
                      Travel Dates
                      </Trans>
                      : {state.triageRequest.EffectFrom}
                      {" "}<Trans i18nKey="findcareoption.Start.Dateto">
                        to
                      </Trans>{" "}
                      {state.triageRequest.EffectTo}
                    </li>
                  )}         
            </ul>
            {state.IsValidUser  && !state.triageRequest.checked && state.triageRequest.insuredInfo &&
                <>
                <Trans  i18nKey="findcareoption.Careoptions.housevisit.primaryInsured"> Primary Insured Details:</Trans>
                <ul>
                {
                    state.triageRequest.data && state.triageRequest.data.insuredOn &&(
                    <li>
                  <Trans  i18nKey="findcareoption.Start.Name"> Name
                  </Trans>: {state.triageRequest.data.insuredOn}
                  
                  </li>
                  )
                }
                {
                    state.triageRequest.data && state.triageRequest.InsuredBirthday &&(
                    <li>
                  <Trans  i18nKey="findcareoption.confirm.Born"> Born 
                  </Trans>: {state.triageRequest.InsuredBirthday}
                  </li>
                  )
                }
                {
                    state.triageRequest.data && state.triageRequest.data.sex &&(
                      <li>
                      <Trans i18nKey="findcareoption.Start.Gender">
                        {" "}
                        Sex
                      </Trans>
                      : {state.triageRequest.data.sex === 'F' ? <Trans i18nKey="userregistration.radio-female">
                        Female
                      </Trans> : <Trans i18nKey="userregistration.radio-male">
                        Male
                      </Trans> }
                    </li>
              )
                }
                {
                    state.triageRequest.data && state.triageRequest.data.relation &&(
                    <li>
                  <Trans  i18nKey="findcareoption.Careoptions.housevisit.relation" > Relation
                  </Trans>: {state.triageRequest.data.relation}
                  </li>
                  )
                }
                </ul>
                </>
              }
        </div>
            <div className="standby-page-navigation standby-page-navigation-align-bottom">
                <button
                    type="button"
                    className="button standby-button standby-button-gradient standby-button-gradient-green"
                    onClick={() => {
                        var isPatientDetailsAdded = checkAndGetLocalStorageValue("isPatientDetailsAdded");
                        localStorage.setItem("phonenumber", state.triageRequest.data.phone)
                        localStorage.setItem("email", state.triageRequest.data.email);
                        state.triageRequest.isCheckboxSelected = state.triageRequest.data.consent
                        actions.updateLogTelemedContactDetails()
                        actions.updateVendorContact();
                        if (isPatientDetailsAdded !=="" && isPatientDetailsAdded == "false") 
                        {
                            actions.updatePatientContact();
                            localStorage.setItem("isPatientDetailsAdded", true);
                        }
                        gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                        history.push(`/find-care-options/done`)
                    }}
                >
                <Trans i18nKey="findcareoption.confirm.confirm">Confirm</Trans>
        </button>
                <Link className="standby-button-back" to={`/find-care-options/telemedicine-info`}>
                    <div className="icon">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 1024 1024"
                        >
                            <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                        </svg>
                    </div>
                    <Trans i18nKey="findcareoption.confirm.Edit_info">Edit info</Trans>
        </Link>
        <div className="standby-page-header standby-page-header-center">
        <Link className="standby-button-back"
              to={ state.UserNavigatedToQT ? '/find-care-options/quick-telemedicine-screen':'/find-care-options/care-options'}>
           <div className="icon">
               <svg
                   version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   width="10"
                   height="10"
                   viewBox="0 0 1024 1024"
               >
                   <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
               </svg>
           </div>
           <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">Cancel Request</Trans>
         </Link>

      </div>
            </div>
        </article>
    </div>
)}